import { recordPath, recordRoute } from '@/shared/registry'

/** Where the training key pages live. */
export const trainingKeysPath = '/entitlements/training-keys'
export const createTrainingKeysPath = `${trainingKeysPath}/new`
export const trainingKeyRoute = recordRoute('entitlements', 'training-keys')
export const editTrainingKeyRoute = `${trainingKeyRoute}/edit`

/** A training key's details page. */
export function trainingKeyPath(id: string): string {
  return recordPath('entitlements', 'training-keys', id)
}

/** A training key's edit page. */
export function editTrainingKeyPath(id: string): string {
  return `${trainingKeyPath(id)}/edit`
}

/** The base of Training Key Details' slots (`detailsSlots`). */
export const trainingKeyDetailsSlot = 'entitlements.training-key-details'

/** The permissions the training key screens show or hide their actions and fields by. */
export const readTrainingKeysPermission = 'entitlements.training-keys.read'
export const writeTrainingKeysPermission = 'entitlements.training-keys.write'
export const deleteTrainingKeysPermission = 'entitlements.training-keys.delete'
export const everyoneTrainingKeysPermission = 'entitlements.training-keys.everyone.write'
export const accessEndTrainingKeysPermission = 'entitlements.training-keys.access-end.write'

/** The API's training key endpoints. */
export const trainingKeysApi = '/entitlements/v1/training-keys'

export function trainingKeyApi(id: string): string {
  return `${trainingKeysApi}/${encodeURIComponent(id)}`
}
